{
  "branding": {
    "frontdesk-attribution": "Работает на FrontDesk+",
    "practice-logo": "Логотип {{name}}"
  },
  "validation": {
    "required": "Это поле обязательно",
    "invalid-url": "Пожалуйста, введите действительный URL",
    "pin-too-short": "PIN должен содержать не менее 4 символов",
    "pin-default-rejected": "Стандартный PIN-код 0000 не допускается. Пожалуйста, назначьте свой собственный PIN-код.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Назад",
    "next": "Далее",
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "done": "Готово",
    "retry": "Повторить",
    "clear": "Очистить",
    "close": "Закрыть",
    "verifying": "Проверка...",
    "select": "Выбрать",
    "minutes": "минут",
    "clock": "",
    "gender": {
      "M": "Мужской",
      "W": "Женский",
      "D": "Другой",
      "U": "Неизвестно"
    },
    "insurance": {
      "GKV": "Государственное",
      "PKV": "Частное",
      "SELFPAY": "Самооплата"
    },
    "scroll-up": "Прокрутить вверх",
    "scroll-down": "Прокрутить вниз"
  },
  "settings": {
    "device-reset": {
      "title": "Сбросить устройство",
      "description": "Удалить подключение к клинике, настройки и PIN-код этого устройства.",
      "confirmation": "Устройство потребуется настроить заново. Конфигурация SOL и данные пациентов в inSuite останутся без изменений.",
      "cancel": "Отмена",
      "confirm": "Сбросить сейчас"
    },
    "title": "Настройки",
    "save": "Сохранить",
    "save-success": "Настройки сохранены",
    "save-error": "Ошибка сохранения",
    "load-error": "Ошибка загрузки настроек",
    "pin": {
      "title": "Требуется PIN",
      "description": "Пожалуйста, введите PIN для доступа к настройкам.",
      "error": "Неверный PIN. Пожалуйста, попробуйте снова.",
      "backspace": "Удалить последнюю цифру"
    },
    "connection": {
      "title": "Подключение",
      "description": "Настройки подключения к серверу Doc-Cirrus Bridge",
      "bridge-url": "URL Bridge",
      "device-name": "Имя устройства",
      "device-name-placeholder": "например. Ресепшен, комната 1, киоск",
      "device-name-hint": "Имя для идентификации на панели управления Bridge",
      "kim-address": "Адрес KIM (необязательно)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Тест",
      "success": "Подключение успешно",
      "error": "Ошибка подключения",
      "api-unreachable": "API DocCirrus недоступен",
      "status-title": "Статус соединения",
      "status": {
        "api": "API подключено",
        "ti": "Телематическая инфраструктура",
        "card-reader": "Доступен картридер",
        "medical-card": "Карта клиники (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol-токен (из inSuite)",
      "sol-token-hint": "Скопируйте из управления Bridge в inSuite. Нужен для подключения.",
      "sol-token-show": "Показать токен",
      "sol-token-hide": "Скрыть токен",
      "bridge-unreachable": "Bridge недоступен. Проверьте адрес и порт.",
      "diagnostic-id": "ID диагностики: {{id}}",
      "scan-qr": "Сканировать QR-код",
      "scan-title": "Сканировать QR-код Bridge",
      "scan-manual": "Ввести вручную"
    },
    "terminal": {
      "title": "Устройство чтения карт",
      "description": "Выбор устройства чтения карт для телематической инфраструктуры",
      "select": "Выбрать терминал",
      "select-placeholder": "Выберите терминал...",
      "loading": "Загрузка терминалов...",
      "none-available": "Терминалы недоступны",
      "none-found": "Терминалы не найдены",
      "found": "Найдено терминалов: {{count}}",
      "connect-hint": "Сначала подключитесь к серверу bridge для загрузки терминалов.",
      "found-count": "Найдено картридеров: {{count}}",
      "refresh": "Обновить список картридеров"
    },
    "practice": {
      "title": "Клиника",
      "description": "Информация о вашей клинике",
      "name": "Название клиники",
      "name-placeholder": "например, Доктор Иван Иванов",
      "welcome-message": "Приветственное сообщение",
      "welcome-placeholder": "например, добро пожаловать в нашу клинику",
      "scheduler-available": "Включить планировщик",
      "scheduler-available-description": "Разрешить пациентам записываться на прием через терминал самообслуживания",
      "prescription-available": "Включить службу рецептов",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Оставьте пустым — приветствие будет на языке пациента. Ваш собственный текст показывается без изменений на всех языках."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Сохранено для всех устройств: {{value}}",
      "never-saved-default": "Настройка по умолчанию, ещё не изменялась."
    },
    "anamnesis": {
      "title": "Цифровая история болезни",
      "description": "Показывает ссылку и QR code для вашего поставщика медицинской истории после регистрации.",
      "enabled": "Показать ссылку на историю болезни после регистрации",
      "enabled-description": "Показывает ссылку и QR code для вашего поставщика медицинских услуг после завершения регистрации, например Nelly.",
      "url": "Ссылка на поставщика медицинской истории",
      "url-hint": "Ссылка статична и одинакова для всех пациентов.",
      "preview-label": "Предварительный просмотр экрана завершения",
      "preview-note": "Ссылка статична и одинакова для всех пациентов.",
      "url-first": "Чтобы включить, сначала введите действительную ссылку."
    },
    "appearance": {
      "title": "Внешний вид",
      "description": "Настройка пользовательского интерфейса",
      "language": "Язык",
      "default-kiosk-language": "Язык пациента по умолчанию",
      "default-kiosk-language-hint": "Язык, на котором начинаются новые сеансы в киосках для пациентов.",
      "voice-over-volume": "Громкость закадрового голоса",
      "voice-over-hint": "Управляет громкостью голосового помощника для обеспечения доступности.",
      "language-first": "Показывать выбор языка в начале сеанса"
    },
    "security": {
      "title": "Безопасность",
      "description": "PIN для доступа к настройкам",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Управление киоском",
    "nav": {
      "general": "Общие",
      "flows": "Функции",
      "anamnese": "Цифровой анамнез",
      "device": "Устройство и подключение"
    },
    "flows": {
      "title": "Функции на терминале"
    },
    "language": {
      "title": "Язык и озвучивание",
      "description": "Язык и чтение вслух для пациентов на этом устройстве."
    }
  },
  "self-service": {
    "title": "Самообслуживание",
    "step-progress": "Шаг {{current}} / {{total}}",
    "flows": {
      "checkin": "Регистрация",
      "scheduler": "Записаться на прием",
      "prescription": "Рецепты",
      "locations": "Карта расположения",
      "emergency": "Экстренная помощь"
    },
    "audio-guide": {
      "on": "Звук включен",
      "off": "Звук выключен",
      "replay": "Повторить инструкцию",
      "replay-unavailable": "Нет голосовой инструкции для повтора"
    },
    "language-selector": {
      "title": "Выберите язык",
      "description": "Пожалуйста, выберите предпочитаемый язык"
    },
    "settings": "Настройки",
    "start": {
      "welcome": "Добро пожаловать",
      "subtitle": "Пожалуйста, выберите опцию",
      "check-in-label": "Основной путь",
      "check-in-cta": "Регистрация",
      "check-in-description": "У вас уже есть запись? Зарегистрируйтесь здесь.",
      "check-in-hint": "Держите карту наготове",
      "scheduler-label": "Новинка",
      "scheduler-cta": "Записаться на прием",
      "scheduler-description": "Запишитесь на новый прием.",
      "location-plan": "Карта расположения",
      "location-plan-description": "Найдите путь к процедурному кабинету.",
      "prescription-label": "Рецепт",
      "prescription-cta": "Рецепты и заказ",
      "prescription-description": "Просматривайте рецепты или заказывайте добавки.",
      "emergency-cta": "Локальный аварийный сигнал",
      "emergency-description": "Звучит только на этом устройстве и не вызывает помощь.",
      "tap-to-start": "Нажмите, чтобы начать"
    },
    "offline": {
      "banner-title": "Регистрация временно недоступна",
      "banner-message": "Пожалуйста, обратитесь за помощью к сотрудникам стойки регистрации.",
      "emergency-available": "Локальный сигнал остаётся доступен. Он не вызывает помощь.",
      "flow-disabled": "Временно недоступно"
    },
    "readability": {
      "toggle-label": "Режим чтения",
      "on": "Режим чтения",
      "off": "Режим чтения"
    },
    "reset-overlay": {
      "timeout-title": "Сессия завершена",
      "timeout-subtitle": "Ваше время истекло. Ваши данные в безопасности.",
      "offline-title": "Соединение потеряно",
      "offline-subtitle": "Соединение прервано. Пожалуйста, поговорите с сотрудниками стойки регистрации.",
      "interruption-title": "Сессия завершена",
      "interruption-subtitle": "Ваша сессия благополучно завершена.",
      "completion-title": "Спасибо!",
      "completion-subtitle": "Ваш запрос успешно выполнен.",
      "reassurance": "Ваши личные данные не хранятся на этом устройстве.",
      "auto-dismiss": "Возврат к началу через {{seconds}} секунд...",
      "dismiss": "К началу"
    },
    "timed-terminal": {
      "countdown": "Автоматический возврат через {{seconds}} секунд.",
      "countdown-outcome": "Этот терминал автоматически вернется к стартовому экрану.",
      "more-time": "Больше времени",
      "extended": "Время продлено"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Эти вопросы недоступны на вашем языке. Выберите один из предложенных языков или обратитесь в регистратуру.",
        "alternatives": "Альтернативные записи",
        "loading": "Загрузка вопросов…",
        "reception-fallback": "Пожалуйста, обратитесь на ресепшен.",
        "error-title": "Не удалось загрузить вопросы",
        "language-unavailable-lead": "Эти вопросы недоступны на вашем языке.",
        "language-unavailable-title": "Пожалуйста, выберите один из этих языков",
        "language-unavailable-body": "Или обратитесь за помощью на ресепшен."
      },
      "start": {
        "title": "Записаться на прием",
        "subtitle": "Запишитесь на удобный прием за несколько шагов",
        "welcome": "Добро пожаловать в запись на прием",
        "description": "Мы проведем вас через процесс записи",
        "cta": "Записаться сейчас"
      },
      "patient-id": {
        "title": "Идентификация",
        "subtitle": "Пожалуйста, представьтесь",
        "mode-card": "С картой",
        "mode-search": "Поиск",
        "mode-create": "Создать новый",
        "insert-card": "Пожалуйста, вставьте вашу страховую карту",
        "reading-card": "Чтение карты...",
        "simulate-card": "Симулировать карту",
        "multiple-matches": "Найдено несколько пациентов. Используются данные карты.",
        "search-placeholder": "Имя или номер страховки...",
        "searching": "Поиск...",
        "no-results": "Результаты не найдены",
        "first-name": "Имя",
        "last-name": "Фамилия",
        "dob": "Дата рождения",
        "insurance": "Страховка",
        "continue": "Продолжить",
        "creating": "Создание пациента...",
        "patient-created": "Пациент успешно создан!",
        "create-error": "Не удалось создать пациента."
      },
      "appointment-type": {
        "title": "Выберите тип приема",
        "subtitle": "Пожалуйста, выберите причину вашего визита",
        "loading": "Загрузка типов приема...",
        "no-types": "Типы приема недоступны",
        "error": "Не удалось загрузить типы приема. Пожалуйста, попробуйте снова.",
        "no-bookable": "Эти типы приемов сейчас нельзя забронировать через киоск. Обратитесь на стойку регистрации или запишитесь по телефону.",
        "disabled-default": "Пожалуйста, запишитесь на этот прием непосредственно на стойке регистрации или по телефону.",
        "disabled-footer": "Только через регистрацию/телефон",
        "lead": "Какой приём вы хотите забронировать?",
        "duration": "ок. {{minutes}} минут",
        "empty-title": "Сейчас здесь нельзя записаться на приём",
        "none-bookable-title": "Эти приёмы здесь забронировать нельзя",
        "none-bookable-body": "Пожалуйста, спросите на ресепшене или позвоните нам."
      },
      "types": {
        "general": "Общая консультация",
        "general-desc": "Для общих жалоб и вопросов",
        "checkup": "Профилактический осмотр",
        "checkup-desc": "Регулярные медицинские осмотры",
        "vaccination": "Вакцинация",
        "vaccination-desc": "Запись на вакцинацию",
        "followup": "Повторный прием",
        "followup-desc": "Контрольный прием",
        "prescription": "Рецепт",
        "prescription-desc": "Получение рецепта"
      },
      "slot-selection": {
        "title": "Выберите прием",
        "subtitle": "Пожалуйста, выберите доступный прием",
        "loading": "Загрузка доступных приемов...",
        "no-slots": "Нет доступных приемов",
        "no-appointment-type": "Тип приема не выбран",
        "error": "Не удалось загрузить доступные слоты. Пожалуйста, попробуйте снова.",
        "quick-select": "Следующие доступные приемы:",
        "select-date": "Или выберите дату:",
        "times-for": "{{date}}",
        "available": "Доступно",
        "unavailable": "Нет слотов",
        "slots": "слоты",
        "select-time-hint": "Нажмите на время, чтобы записаться",
        "week-short": "Нед",
        "weekday-mon": "Пн",
        "weekday-tue": "Вт",
        "weekday-wed": "Ср",
        "weekday-thu": "Чт",
        "weekday-fri": "Пт",
        "weekday-sat": "Сб",
        "weekday-sun": "Вс",
        "period-morning": "Утро",
        "period-midday": "Полдень",
        "period-afternoon": "День",
        "period-evening": "Вечер",
        "period-morning-short": "Утро",
        "period-midday-short": "Полд.",
        "period-afternoon-short": "День",
        "period-evening-short": "Вечер",
        "period-dots-legend": "Доступность времени",
        "filter-hint": "Фильтр по предпочитаемому времени:",
        "or-choose-below": "или выберите ниже",
        "no-slots-period": "Нет слотов",
        "show-all": "Показать все",
        "free": "бесплатно",
        "your-selection": "Ваш выбор",
        "oclock": "часов",
        "choose-slot": "Выбрать слот",
        "choose-day": "Выберите день",
        "choose-day-first": "Сначала выберите день",
        "times-heading": "Свободное время {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Нет свободных приёмов: {{month}}",
        "empty-body": "Посмотрите следующий месяц или спросите на ресепшене — мы с радостью поможем.",
        "next-month": "Следующий месяц",
        "previous-month": "Предыдущий месяц"
      },
      "confirmation": {
        "patient-responses": "Ваши ответы",
        "review-loading": "Проверка сводки…",
        "review-unavailable": "Сводка недоступна. Пожалуйста, попробуйте ещё раз или спросите на ресепшене.",
        "check-booking": "Проверить запись",
        "title": "Подтвердите прием",
        "subtitle": "Пожалуйста, проверьте вашу запись",
        "patient": "Пациент",
        "datetime": "Дата и время",
        "booking": "Запись...",
        "confirm": "Записаться",
        "heading": "Это выглядит правильно?",
        "lead": "Пожалуйста, подтвердите вашу встречу.",
        "appointment": "Назначение",
        "insured-via": "Застраховано через",
        "description-label": "Примечания для клиники (необязательно)",
        "description-hint": "Сообщите нам, если при записи на прием или регистрации нужно что-то учесть.",
        "description-placeholder": "например, ограниченная подвижность, сопровождающий, важные указания",
        "description-too-long": "Пожалуйста, сократите примечание до 500 символов.",
        "summary": "Краткое содержание",
        "change": "Изменение",
        "book-binding": "Записаться на прием",
        "cancel": "Отмена",
        "type-label": "Вид приёма",
        "datetime-value": "{{date}} в {{time}}",
        "name-label": "Имя",
        "insurance-label": "Страховка",
        "insurance-GKV": "Обязательное медицинское страхование",
        "insurance-PKV": "Частное медицинское страхование",
        "insurance-SELFPAY": "Самостоятельная оплата",
        "change-time": "Изменить приём",
        "description-free-text": "Другие пожелания (необязательно)",
        "note-wheelchair": "Я пользуюсь инвалидной коляской",
        "note-companion": "Я приду с сопровождающим",
        "note-interpreter": "Мне нужен переводчик"
      },
      "done": {
        "title": "Прием записан!",
        "label": "Забронировано",
        "subtitle": "Ваш прием успешно записан.",
        "date": "Дата",
        "time": "Время",
        "booking-id": "Номер записи",
        "qr-hint": "Добавить в календарь",
        "qr-description": "Отсканируйте этот QR-код камерой смартфона, чтобы добавить прием в календарь",
        "auto-redirect": "Вы будете перенаправлены на начальную страницу в ближайшее время...",
        "auto-redirect-countdown": "Возврат к началу через {{seconds}} секунд...",
        "back-to-start": "Вернуться к началу",
        "print-button": "Распечатать талон на приём",
        "print-preparing": "Подготовка окна печати…",
        "print-error": "Не удалось открыть талон на приём. Повторите попытку или обратитесь за помощью в регистратуру.",
        "print-returned": "Системное окно печати закрыто. При необходимости можно запросить ещё одну копию.",
        "print-title": "Ваш приём",
        "print-location": "Место",
        "print-map-hint": "Открыть место на телефоне",
        "print-error-v2": "Не удалось открыть талон на приём. Пожалуйста, попробуйте ещё раз или спросите на ресепшене."
      },
      "error": {
        "assistance-info": "Не удалось подтвердить запись. Возможно, приём уже забронирован. Пожалуйста, спросите на ресепшене.",
        "pending-title": "Запись не подтверждена",
        "pending-info": "Не удалось подтвердить запись. Возможно, приём уже забронирован. Пожалуйста, проверьте ещё раз или спросите на ресепшене.",
        "title": "Ошибка записи",
        "subtitle": "Не удалось записать прием.",
        "info": "Пожалуйста, попробуйте ещё раз или спросите на ресепшене."
      },
      "phase": {
        "identify": "Регистрация",
        "choose": "Выбор времени",
        "confirm": "Подтверждение"
      }
    },
    "prescription": {
      "start": {
        "title": "Рецепты и заказ",
        "subtitle": "Вставьте свою страховую карту, чтобы просмотреть рецепты или заказать пополнение запасов.",
        "button": "Вставьте карту"
      },
      "card-check": {
        "loading": "Загрузка картридера...",
        "no-terminal": "Не настроен кард-ридер",
        "no-terminal-hint": "Пожалуйста, обратитесь за помощью к персоналу.",
        "insert-card": "Пожалуйста, вставьте свою карту",
        "insert-card-hint": "Вставьте свою страховую карту в устройство считывания карт.",
        "card-detected": "Карта обнаружена",
        "reading": "Чтение карты...",
        "reading-hint": "Пожалуйста, подождите немного.",
        "error": "Ошибка чтения карты",
        "retry": "Попробуйте еще раз",
        "manual-lookup": "Продолжить без карты",
        "load-error": "Не удалось загрузить устройство чтения карт",
        "read-error": "Невозможно прочитать карту"
      },
      "patient-selection": {
        "title": "Выбрать пациента",
        "subtitle": "Было обнаружено несколько пациентов. Пожалуйста, выберите свое имя.",
        "try-again": "Попробуйте еще раз",
        "try-again-hint": "Вставьте карту еще раз"
      },
      "list": {
        "title": "Ваши рецепты",
        "for-patient": "Предписания для {{name}}",
        "loading": "Загрузка рецептов...",
        "error-title": "Ошибка загрузки",
        "fetch-error": "Не удалось загрузить рецепты.",
        "back-home": "Вернуться к началу",
        "done": "Готово"
      },
      "detail": {
        "prescription-info": "Информация о рецепте",
        "date": "Дата",
        "prescriber": "Врач, назначающий препарат",
        "comment": "Примечание",
        "medications": "Лекарства",
        "form": "Форма",
        "pack-size": "Размер упаковки",
        "manufacturer": "Производитель",
        "loading": "Загрузка рецепта...",
        "fetch-error": "Не удалось загрузить сведения о рецепте.",
        "back-to-list": "Вернуться к списку",
        "print": "Распечатать"
      },
      "types": {
        "public": "Государственный рецепт",
        "private": "Частный рецепт",
        "long-term": "Долгосрочный рецепт",
        "btm": "Рецепт на наркотические средства",
        "g": "Зеленый рецепт",
        "t": "Т-рецепт"
      },
      "no-patient": {
        "title": "Пациент не найден",
        "subtitle": "К сожалению, по этой карте не найден ни один пациент. Пожалуйста, свяжитесь с персоналом для получения помощи.",
        "try-again": "Попробуй еще раз",
        "back-home": "Вернуться к началу",
        "title-v2": "Подходящие данные не найдены",
        "subtitle-v2": "Не удалось вас найти. Пожалуйста, попробуйте ещё раз или спросите на ресепшене."
      },
      "done": {
        "title": "Спасибо",
        "subtitle": "Теперь вы можете присесть. Если у вас есть вопросы, пожалуйста, свяжитесь с персоналом.",
        "no-prescriptions-title": "Рецептов в деле нет.",
        "no-prescriptions-subtitle": "Нам не удалось найти для Вас действующих рецептов. Если вы этого ожидали, пожалуйста, свяжитесь с сотрудниками стойки регистрации.",
        "error-title": "Произошла ошибка",
        "error-subtitle": "Пожалуйста, свяжитесь с персоналом для получения дополнительной помощи.",
        "auto-redirect": "Автоматическое перенаправление за {{seconds}} секунд",
        "finish": "Вернуться к началу"
      },
      "hub": {
        "title": "Ваши рецепты",
        "for-patient": "Предписания для {{name}}",
        "loading": "Загрузка рецептов...",
        "error-title": "Ошибка загрузки",
        "fetch-error": "Не удалось загрузить рецепты.",
        "back-home": "Вернуться к началу",
        "done": "Готово",
        "order-button": "Рецепт заказа",
        "existing-prescriptions": "Ваши текущие рецепты",
        "no-prescriptions": "Активных рецептов не найдено."
      },
      "patient-lookup": {
        "title": "Найти пациента",
        "subtitle": "Введите свое имя и дату рождения.",
        "last-name": "Фамилия",
        "first-name": "Имя",
        "date-of-birth": "Дата рождения",
        "lastname": "Фамилия",
        "lastname-placeholder": "Ваша фамилия",
        "firstname": "Имя",
        "firstname-placeholder": "Ваше имя",
        "dob": "Дата рождения",
        "search": "Поиск",
        "searching": "Ищем...",
        "search-error": "Ошибка поиска: {{message}}",
        "no-match": "Пациент не найден. Пожалуйста, проверьте вашу информацию.",
        "error": "Ошибка поиска. Пожалуйста, попробуйте еще раз.",
        "found": "Обнаружен пациент",
        "confirm": "Подтвердить",
        "ambiguous": "Несколько совпадений",
        "ambiguous-hint-firstname": "Пожалуйста, также введите свое имя, чтобы уточнить поиск.",
        "ambiguous-hint-additional": "Пожалуйста, проверьте свою информацию или свяжитесь с персоналом.",
        "not-found": "Пациент не найден",
        "not-found-hint": "Не удалось найти ни одного пациента с такими данными.",
        "not-found-action": "Попробуйте еще раз"
      },
      "manual-identification": {
        "unverified": "Ваша личность не подтверждена с помощью медицинской страховой карты. Практика проверит ваши данные и запрос перед обработкой."
      },
      "medication-selection": {
        "title": "Запрос рецепта",
        "subtitle": "Клиника рассматривает ваш запрос. После одобрения eRx будет готов в вашем приложении e-prescription.",
        "back": "Назад",
        "submit": "Продолжить просмотр",
        "reason-title": "Зачем вам нужен рецепт?",
        "reason-hint": "Помогает клинике оценить ваш запрос.",
        "reason-validation": "Пожалуйста, выберите причину.",
        "reason-schmerzen": "Боль",
        "reason-entzuendung": "Воспаление",
        "reason-nachsorge": "После операции процедура /",
        "reason-allergie": "Аллергия Реакция /",
        "reason-chronisch": "Хроническое состояние",
        "reason-anderes": "Что-то еще",
        "medications-title": "Какие лекарства?",
        "request-hint": "Опишите, что вам нужно, или назовите предыдущий рецепт, который вы хотите продлить.",
        "request-placeholder": "напр. Ибупрофен 600 мг, как и в прошлый раз.",
        "request-validation": "Пожалуйста, опишите, какое лекарство вам необходимо.",
        "history-title": "Предыдущие рецепты",
        "history-hint": "Добавьте запись для предварительного заполнения вашего запроса.",
        "history-loading": "Загрузка предыдущих рецептов...",
        "history-error": "Не удалось загрузить предыдущие рецепты.",
        "history-add": "Добавить",
        "history-added": "Добавлено",
        "history-date": "Последний: {{date}}",
        "history-request-line": "Продлить: {{medicationName}}",
        "urgency-title": "Насколько это срочно?",
        "urgency-hint": "Помогает клинике расставить приоритеты.",
        "urgency-soon": "Срочно",
        "urgency-soon-meta": "Как можно скорее",
        "urgency-tomorrow": "Скоро",
        "urgency-tomorrow-meta": "В ближайшие дни",
        "urgency-week": "На этой неделе",
        "urgency-week-meta": "Никакого цейтнота",
        "lead": "Практика рассмотрит ваш запрос. После одобрения электронный рецепт будет доступен в приложении для электронных рецептов или на вашей страховой карте.",
        "history-hint-v2": "Нажмите на прежний рецепт, чтобы добавить его.",
        "history-retry": "Загрузить снова"
      },
      "request-review": {
        "title": "Порядок рассмотрения",
        "subtitle": "Пожалуйста, просмотрите свой запрос на рецепт.",
        "request-label": "Запрошенное лекарство",
        "selected-medications": "Отдельные лекарства",
        "free-text-medications": "Дополнительные лекарства",
        "freetext-label": "Другое",
        "quarterly-warning": "Ваша страховая карта не была считана в этом квартале. Клиника может связаться с вами.",
        "egk-warning": "Ваша страховая карта не была считана в этом квартале. Клиника может связаться с вами.",
        "submit": "Отправить",
        "submitting": "Отправка...",
        "submit-error": "Не удалось отправить запрос. Пожалуйста, попробуйте еще раз.",
        "back": "Назад",
        "reason-label": "Причина",
        "urgency-label": "Срочность",
        "completion-email-choice": "Я хочу получить письмо, когда клиника обработает мой запрос.",
        "completion-email-label": "Адрес электронной почты",
        "completion-email-placeholder": "name@example.com",
        "completion-email-hint": "Только для этого разового сообщения. Адрес не сохраняется в основных данных.",
        "completion-email-invalid": "Введите действительный адрес электронной почты.",
        "egk-proof-required": "Запрос рецепта доступен только после успешного считывания страховой карты. Обратитесь к персоналу.",
        "title-v2": "Проверить запрос",
        "completion-email-hint-v2": "Адрес используется только для этого одного сообщения."
      },
      "confirmation": {
        "title": "Запрос отправлен",
        "subtitle": "Ваш запрос на рецепт успешно отправлен.",
        "success-title": "Запрос отправлен",
        "success-subtitle": "Ваш запрос на рецепт успешно отправлен.",
        "estimated-time": "Ваш рецепт будет готов примерно через {{time}}.",
        "info": "Вы можете получить рецепт в аптеке, используя страховую карту или приложение eRezept.",
        "auto-redirect": "Автоматическое перенаправление за {{seconds}} секунд",
        "back-to-start": "Вернуться к началу",
        "handling-label": "Handled by the practice",
        "next-steps": "Практика рассмотрит ваш запрос. После одобрения вы сможете получить лекарство по электронному рецепту в аптеке со страховой картой или через приложение для электронных рецептов."
      },
      "phase": {
        "identify": "Регистрация",
        "request": "Запрос",
        "review": "Проверка"
      }
    },
    "check-in": {
      "flow-label": "Регистрация",
      "has-appointment": {
        "eyebrow": "Назначение",
        "title": "У вас есть запись?",
        "subtitle": "Пожалуйста, выберите опцию",
        "yes-label": "Да",
        "yes": "Да, у меня есть запись",
        "yes-description": "Я хочу зарегистрироваться на прием.",
        "yes-hint": "Самый быстрый путь",
        "unsure-label": "Возможно",
        "unsure": "Я не уверен",
        "unsure-description": "Мы проверим это для вас.",
        "unsure-hint": "Мы будем искать вас",
        "no-label": "Нет",
        "no": "Нет, без записи",
        "no-description": "У меня нет записи.",
        "no-hint": "Прогулка"
      },
      "card-check": {
        "eyebrow": "Страховая карта",
        "title": "Прочитать страховую карту",
        "subtitle": "Пожалуйста, вставьте страховую карту в устройство чтения",
        "insert-title": "Вставьте страховую карту в считыватель.",
        "insert-detail": "Мы считываем ваши данные автоматически — вам больше ничего делать не нужно.",
        "other-ways": "Другие способы",
        "no-card-hint": "Если в данный момент у вас нет с собой карты.",
        "pkv-hint": "Используйте QR code со своим страховым приложением.",
        "loading": "Загрузка настроек...",
        "no-terminal": "Устройство чтения карт не настроено. Пожалуйста, обратитесь к персоналу.",
        "checking": "Проверка карт...",
        "insert-prompt": "Пожалуйста, вставьте карту...",
        "card-detected": "Карта обнаружена! Готово к чтению.",
        "read-card": "Прочитать карту",
        "simulate-insert": "Симулировать карту",
        "reading": "Чтение карты...",
        "error": "Не удалось прочитать карту. Пожалуйста, попробуйте снова.",
        "read-error": "Не удалось прочитать данные карты. Пожалуйста, попробуйте снова.",
        "settings-error": "Не удалось загрузить настройки. Пожалуйста, попробуйте снова.",
        "no-card-prompt": "Нет карты с собой?",
        "no-card-action": "Ручной поиск",
        "connection-warning": "Проблемы с подключением кард-ридера. Пожалуйста, подождите...",
        "pkv-prompt": "Частное страхование? Online Check-in",
        "pkv-instruction": "Отсканируйте этот QR code с помощью приложения частного медицинского страхования, чтобы передать данные в цифровом виде.",
        "pkv-continue": "Перейти к ручной регистрации",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Попробуйте ещё раз или зарегистрируйтесь без карты. На ресепшене вам охотно помогут.",
        "title-pkv": "Регистрация через приложение",
        "title-reading": "Ваша карта считывается …",
        "title-unreadable": "Не удалось прочитать карту",
        "title-no-terminal": "Регистрация без карты",
        "no-terminal-body": "Устройство для чтения карт сейчас недоступно. Зарегистрируйтесь без карты или обратитесь на ресепшен.",
        "reading-detail": "Пожалуйста, не вынимайте карту. Это займёт всего минуту.",
        "other-ways-title": "Другие возможности",
        "no-card-title": "Зарегистрироваться без карты",
        "pkv-prompt-title": "Частная страховка?",
        "pkv-prompt-hint": "Регистрация через приложение вашей частной медицинской страховки",
        "pkv-close": "Всё-таки с картой",
        "pkv-instruction-app": "Откройте приложение своей частной медицинской страховки и отсканируйте этот код. Ваши данные придут прямо к нам."
      },
      "patient-selection": {
        "title": "Выберите пациента",
        "subtitle": "Найдено несколько пациентов. Пожалуйста, выберите себя.",
        "firstname-label": "Ваше имя",
        "firstname-placeholder": "Введите имя...",
        "confirm-button": "Подтвердить",
        "no-match": "Подходящего пациента не обнаружено. Пожалуйста, обратитесь на стойку регистрации за помощью.",
        "still-ambiguous": "Осталось несколько совпадений. Пожалуйста, обратитесь на стойку регистрации за помощью.",
        "select-error": "Не удалось идентифицировать пациента. Пожалуйста, попробуйте еще раз.",
        "staff-assist": "Пройти на стойку регистрации",
        "title-v2": "Короткий вопрос",
        "subtitle-v2": "Для надёжности введите своё имя.",
        "no-match-v2": "Мы не нашли вас с этим именем. Проверьте написание или обратитесь на ресепшен.",
        "still-ambiguous-v2": "Нам пока не удалось однозначно найти вас. Обратитесь на ресепшен.",
        "select-error-v2": "К сожалению, не получилось. Попробуйте ещё раз."
      },
      "card-checkin": {
        "title": "Подтвердите регистрацию",
        "subtitle": "Ваши данные успешно прочитаны.",
        "confirm": "Подтвердить регистрацию"
      },
      "register-from-card": {
        "title": "Новая регистрация",
        "subtitle": "Вас еще нет в нашей системе. Хотите зарегистрироваться?",
        "card-data": "Данные карты",
        "create": "Зарегистрироваться",
        "create-error": "Регистрация не удалась. Пожалуйста, попробуйте еще раз или обратитесь за помощью к персоналу.",
        "staff-assist": "Вызов персонала",
        "no-card-data-title": "Нет данных карты",
        "no-card-data": "Невозможно прочитать данные с вашей карты.",
        "insurance-verified": "Страховка подтверждена: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Ваши данные с карты",
        "subtitle-v2": "Проверьте свои данные. Если что-то неверно, нажмите «Изменить».",
        "create-v2": "Подтвердить данные",
        "create-error-v2": "Регистрация, к сожалению, не удалась. Попробуйте ещё раз или обратитесь на ресепшен.",
        "insurer-missing-v2": "На вашей карте нет данных о больничной кассе. Обратитесь на ресепшен.",
        "edit": "Изменить",
        "name": "Имя",
        "insurer": "Больничная касса"
      },
      "patient-lookup": {
        "title": "Поиск пациента",
        "subtitle": "Пожалуйста, введите ваше имя или номер страховки.",
        "lastname": "Фамилия",
        "lastname-placeholder": "Ваша фамилия",
        "dob": "Дата рождения",
        "firstname": "Имя",
        "firstname-placeholder": "Ваше имя",
        "search": "Поиск",
        "searching": "Поиск...",
        "search-placeholder": "Имя или номер страховки...",
        "results-placeholder": "Результаты поиска появятся здесь",
        "found": "Пациент найден!",
        "confirm-identity": "Пожалуйста, подтвердите, что вы являетесь показанным пациентом.",
        "confirm-button": "Это я",
        "ambiguous-firstname": "Было обнаружено несколько пациентов. Пожалуйста, введите свое имя.",
        "ambiguous-additional": "Было обнаружено несколько пациентов. Пожалуйста, свяжитесь с персоналом.",
        "disambiguation-hint": "Это поможет нам четко идентифицировать вас.",
        "not-found": "Ни один пациент с такими данными не был найден.",
        "error": "Ошибка поиска: {{message}}",
        "staff-assist": "Вызов персонала",
        "not-found-prompt": "Не найдено?",
        "register-new": "Зарегистрироваться",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Регистрация без карты",
        "subtitle-firstname": "Введите также своё имя.",
        "ambiguous-firstname-v2": "Есть несколько человек с этой фамилией. Введите также своё имя.",
        "search-again": "Искать снова",
        "found-v2": "Мы вас нашли",
        "found-confirm": "Подтвердите кнопкой «Это я».",
        "not-found-title": "Мы вас не нашли",
        "not-found-check": "Проверьте написание и дату рождения. На ресепшене вам охотно помогут.",
        "not-found-reception": "Проверьте написание и дату рождения или обратитесь на ресепшен.",
        "ambiguous-additional-v2": "Нам не удалось однозначно найти вас. Обратитесь на ресепшен.",
        "error-v2": "Поиск сейчас не сработал. Попробуйте ещё раз."
      },
      "checking-in": {
        "title": "Один момент — мы вас регистрируем.",
        "subtitle": "Мы добавляем вас в очередь на лечение и уведомляем команду.",
        "step-insurance": "Страховка проверена",
        "step-appointment": "Назначение подтверждено",
        "step-waitlist": "Добавление в список ожидания",
        "error": "Регистрация не удалась. Пожалуйста, попробуйте еще раз.",
        "continue": "Все равно продолжить",
        "title-v2": "Минутку, пожалуйста",
        "loading": "Регистрируем вас …",
        "subtitle-v2": "Записываем вас в список ожидания и сообщаем команде.",
        "error-title": "К сожалению, не получилось",
        "error-v2": "Не удалось завершить вашу регистрацию.",
        "error-body": "Попробуйте ещё раз. Если снова не получится, вам поможет ресепшен."
      },
      "appointment-selection": {
        "title": "Выбрать встречу",
        "subtitle": "У вас сегодня несколько встреч. Пожалуйста, выберите один.",
        "checking-in": "Проверяем...",
        "time": "{{time}}",
        "error-v2": "Регистрация на этот приём не удалась. Попробуйте ещё раз или обратитесь на ресепшен."
      },
      "no-appointment": {
        "title": "Встречи не найдены",
        "subtitle": "Нам не удалось найти для вас встречу сегодня. Пожалуйста, запишитесь на регулярный прием.",
        "book-appointment": "Записаться на прием",
        "book-appointment-description": "Запишитесь на новую встречу через обычный планировщик.",
        "staff-assist": "Вызовите персонал",
        "staff-assist-description": "Мне нужна помощь.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Сегодня мы не нашли для вас записи.",
        "book-v2": "Записаться на новый приём",
        "book-v2-description": "Выберите свободное время.",
        "have-appointment": "У меня есть запись",
        "have-appointment-description": "На ресепшене вам охотно помогут.",
        "unavailable-title": "Записаться на приём можно на ресепшене",
        "subtitle-unavailable": "Сегодня мы не нашли для вас записи. Обратитесь на ресепшен."
      },
      "staff-assist": {
        "title": "Уведомление персонала",
        "subtitle": "Сотрудник скоро вам поможет.",
        "message": "Пожалуйста, подождите здесь. Сотрудник скоро будет с вами.",
        "start-over": "К началу",
        "auto-redirect": "Возврат к началу через {{seconds}} секунд..."
      },
      "eeb-prompt": {
        "title": "Проверить страховку",
        "title-failed": "Проверка не удалась",
        "subtitle": "Как вы хотите проверить страховку?",
        "subtitle-failed": "Отсканируйте QR-код с помощью приложения страховой компании для запроса проверки.",
        "verify-card": "Проверить электронно",
        "verify-card-description": "Отправить запрос вашей страховой компании.",
        "select-insurer": "Выбрать страховщика",
        "select-insurer-description": "Ручной выбор вашего страховщика.",
        "skip": "Пропустить",
        "eyebrow-chip": "Альтернатива",
        "eyebrow": "Регистрация · подтверждение страховки (eEB)",
        "recommended": "Рекомендуется",
        "qr-title": "Сканируйте с помощью страхового приложения",
        "qr-description": "Откройте приложение медицинского страхования и отсканируйте код — eEB будет отправлен непосредственно нам.",
        "qr-address-label": "Отправить по адресу",
        "title-app": "Подтверждение через приложение",
        "subtitle-app": "Ваша больничная касса может отправить нам подтверждение напрямую. Когда закончите, нажмите «Далее»."
      },
      "quarterly-check": {
        "title": "Проверка страховки",
        "checking": "Мы проверяем вашу текущую страховую проверку...",
        "error": "Проверка не может быть выполнена.",
        "title-v2": "Ваша страховка",
        "checking-v2": "Проверяем вашу страховку – минутку, пожалуйста.",
        "error-body": "Ваша регистрация завершена. Вопрос страховки ресепшен решит вместе с вами."
      },
      "insurer-prefilled": {
        "title": "Ваша медицинская страховка",
        "subtitle": "Пожалуйста, подтвердите вашу страховку на этот квартал.",
        "your-insurance": "Ваша страховка",
        "last-read": "Последняя проверка {{date}}",
        "quarterly-notice": "Для выставления счета нам нужно текущее подтверждение страховки на этот квартал.",
        "confirm-button": "Да, это моя страховка",
        "change-button": "У меня другая страховка",
        "contact-title": "Запросить электронное подтверждение страхового покрытия",
        "contact-description": "Позвоните в свою страховую компанию и запросите электронное подтверждение покрытия:",
        "contact-patient": "Пациент",
        "contact-kim-address": "KIM-адрес клиники",
        "contact-phone": "Телефон",
        "question": "Это ваша больничная касса?",
        "quarterly-notice-v2": "Раз в квартал нам нужно подтверждение от вашей больничной кассы."
      },
      "insurer-search": {
        "title": "Выберите медицинскую страховку",
        "subtitle": "Пожалуйста, найдите и выберите вашу государственную медицинскую страховку.",
        "placeholder": "Поиск страховки...",
        "hint": "Введите не менее 2 символов для поиска.",
        "no-results": "Страховка не найдена.",
        "no-results-hint": "Проверьте правописание или попробуйте другой поиск.",
        "label": "Название вашей больничной кассы",
        "search-error-v2": "Поиск сейчас не сработал. Попробуйте ещё раз.",
        "app-alternative": "Лучше через приложение больничной кассы?"
      },
      "insurer-contact": {
        "title": "Запросить подтверждение страхования",
        "subtitle": "Пожалуйста, выберите один из следующих вариантов.",
        "or": "или",
        "option-eeb-title": "Запрос в электронном виде",
        "option-eeb-description": "Если имеется предусмотренный законом особый случай, вы можете после своего согласия передать запрос команде практики.",
        "option-qr-title": "Сканирование с помощью приложения",
        "option-qr-description": "Отсканируйте QR code с помощью страхового приложения.",
        "option-call-title": "Позвоните сами",
        "option-call-description": "Позвоните в свою страховую компанию и запросите eEB для этой клиники:",
        "phone": "Телефон",
        "phone-not-available": "Номер телефона, указанный на вашей страховой карте.",
        "patient-name": "Пациент",
        "practice-kim": "KIM-адрес клиники",
        "help-notice": "Если у вас возникнут проблемы, обратитесь на стойку регистрации.",
        "submit-eeb-button": "Запросить сейчас",
        "contacted-button": "Я позвонил",
        "contacted-button-countdown": "Время вашего звонка ({{seconds}}s)",
        "go-to-counter-button": "Пройти на стойку регистрации",
        "qr-continue-button": "Я отсканировал",
        "qr-continue-button-countdown": "Время сканирования ({{seconds}}s)",
        "title-v2": "Подтверждение от вашей больничной кассы",
        "subtitle-v2": "Проще всего через приложение вашей больничной кассы.",
        "subtitle-no-app": "Выберите, как больничная касса должна отправить нам подтверждение.",
        "option-eeb-description-v2": "Мы сами запросим подтверждение у вашей кассы. Для этого нужно ваше согласие.",
        "call-instruction": "Позвоните в больничную кассу и попросите отправить подтверждение в нашу практику.",
        "call-instruction-practice": "Позвоните в больничную кассу и попросите отправить подтверждение в практику {{practice}}.",
        "done-button": "Готово – далее",
        "done-button-countdown": "Готово – далее (ещё {{seconds}} с)"
      },
      "eeb-consent": {
        "title": "Согласие",
        "subtitle": "Нам нужно ваше согласие на электронную проверку страховки.",
        "insurance": "Ваша страховка",
        "consent-title": "Согласие на электронную проверку страховки (eEB)",
        "consent-text": "Я понимаю, что моя медицинская страховка передаст мои страховые данные (например, имя, дату рождения, номер страховки) через защищенную службу связи KIM в клинику {{practiceName}} в качестве подтверждения страховки. Я согласен(на) на эту передачу. Я знаю, что могу отозвать это согласие в любое время без влияния на мое лечение.",
        "withdrawal-notice": "Вы можете отозвать это согласие в любое время.",
        "agree-button": "Я согласен",
        "decline-button": "Отмена",
        "treatment-notice": "Ваше лечение не зависит от этого согласия.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Подтверждение от вашей больничной кассы",
        "summary": "Ваша больничная касса отправляет нам подтверждение напрямую. Для этого нужно ваше согласие.",
        "confirm-first": "Сначала подтвердите заявление."
      },
      "qr-code": {
        "title": "Отсканируйте приложением страховой компании",
        "instruction-1": "Откройте приложение вашей страховой компании и отсканируйте этот QR-код.",
        "instruction-2": "После этого клиника автоматически получит подтверждение вашей страховки.",
        "practice": "Клиника: {{name}}",
        "alternative-hint": "Альтернатива: используйте приложение страховой компании",
        "instruction-app": "Откройте приложение своей больничной кассы и отсканируйте этот код. Подтверждение придёт прямо к нам.",
        "staff-line": "Для команды практики: {{address}}",
        "staff-line-practice": "Для команды практики: {{name}} · {{address}}",
        "alternative-app": "Подтверждение можно запросить и через приложение кассы: откройте приложение и отсканируйте этот код."
      },
      "register-basics": {
        "title": "Личная информация",
        "subtitle": "Пожалуйста, введите ваши данные.",
        "family-name": "Фамилия",
        "given-name": "Имя",
        "dob": "Дата рождения",
        "gender": "Пол",
        "insurance-type": "Тип страховки",
        "insurer-name": "Название вашей страховки",
        "insurer-name-placeholder": "напр. Дебека, ДКВ, Альянц...",
        "gender-required": "Выберите один вариант."
      },
      "register-insurer": {
        "title": "Медицинская страховка",
        "subtitle": "Пожалуйста, выберите вашу медицинскую страховку.",
        "search-placeholder": "Поиск страховки..."
      },
      "register-details": {
        "title": "Сводка",
        "subtitle": "Пожалуйста, проверьте вашу информацию.",
        "create": "Завершить регистрацию",
        "missing-data": "Пожалуйста, заполните все обязательные поля.",
        "create-error": "Регистрация не удалась. Пожалуйста, попробуйте еще раз.",
        "policy-number": "Номер полиса (необязательно)",
        "policy-number-placeholder": "Номер вашего полиса",
        "create-v2": "Завершить регистрацию",
        "policy-number-hint": "Номер указан на карте вашей страховки."
      },
      "diff-review": {
        "eyebrow-chip": "Обзор",
        "eyebrow": "Регистрация · данные карты",
        "title": "Сравнение данных",
        "subtitle": "Обнаружены различия между данными вашей карты и нашими записями.",
        "col-current": "Текущий рекорд",
        "col-new": "Новое с карты",
        "new-badge": "новый",
        "field-fallback": "Поле",
        "note": "Обновленные данные помогают нам правильно выставлять счета и связаться с вами в экстренной ситуации.",
        "comparison-placeholder": "Сравнение будет показано здесь",
        "confirm": "Подтвердить изменения",
        "apply-error": "Не удалось применить данные. Пожалуйста, попробуйте еще раз.",
        "retry": "Попробуйте еще раз",
        "skip": "Все равно продолжить",
        "no-changes": "Изменения не найдены",
        "title-v2": "Ваши данные изменились",
        "subtitle-v2": "На вашей карте более новые данные. Принять их?",
        "confirm-v2": "Принять и зарегистрироваться",
        "keep": "Зарегистрироваться без изменений",
        "col-current-v2": "Раньше",
        "col-new-v2": "Новое с карты",
        "value-yes": "Да",
        "value-no": "Нет"
      },
      "insurance-selection": {
        "title": "Тип страховки",
        "subtitle": "Пожалуйста, выберите тип вашей страховки.",
        "gkv": "Государственная страховка",
        "gkv-description": "Член государственной медицинской страховки.",
        "pkv": "Частная или самооплата",
        "pkv-description": "Частная страховка или самооплата.",
        "pkv-description-v2": "Частная медицинская страховка, или вы платите сами."
      },
      "eeb-request": {
        "title": "Запрос зарегистрирован",
        "subtitle": "Вы можете завершить регистрацию. Ответ от {{insurer}} поступит в практику позже.",
        "verifying": "Ваш запрос принят к немедленной обработке.",
        "success": "Ваш запрос безопасно передан команде практики.",
        "error": "Подтверждение запроса недоступно.",
        "try-alternative": "Альтернативный метод",
        "kim-load-error": "Не удалось загрузить KIM-адрес клиники.",
        "kim-label": "Клиника · KIM",
        "non-blocking-note": "Это ещё не подтверждает получение вашей больничной кассой или ваш страховой статус.",
        "auto-continue": "Автоматический переход через {{seconds}} секунд.",
        "unavailable-title": "К сожалению, не получилось",
        "unavailable-v2": "Не удалось зарегистрировать ваш запрос в больничную кассу.",
        "unavailable-body": "Вы можете запросить подтверждение через приложение кассы или решить вопрос на ресепшене.",
        "use-app": "Через приложение",
        "at-reception": "Решить на ресепшене"
      },
      "self-pay": {
        "title": "Самооплата",
        "subtitle": "Вы будете лечиться как пациент с самооплатой.",
        "info": "Пожалуйста, обратите внимание, что вы будете нести ответственность за расходы на лечение.",
        "confirm": "Понятно",
        "title-v2": "Вы платите сами",
        "subtitle-v2": "Вы оплачиваете лечение сами.",
        "insured-after-all": "Всё-таки застрахован"
      },
      "done": {
        "title": "Готово!",
        "subtitle": "Ваша регистрация завершена.",
        "finish": "Завершить",
        "done-label": "Готово",
        "error-label": "Уведомление",
        "eyebrow": "Регистрация · завершена",
        "queue-label": "Зал ожидания",
        "queue-title": "Пожалуйста, присаживайтесь",
        "queue-meta": "Мы позвоним Вам лично.",
        "success-title": "Регистрация успешна!",
        "success-subtitle": "Пожалуйста, займите место в зале ожидания. Вас вызовут.",
        "auto-redirect": "Вы будете перенаправлены на начальную страницу в ближайшее время...",
        "auto-redirect-countdown": "Возврат к началу через {{seconds}} секунд...",
        "card-expired-title": "Карта просрочена",
        "card-expired-subtitle": "Ваша страховая карта просрочена.",
        "card-expired-info": "Пожалуйста, обратитесь к персоналу за помощью.",
        "back-to-start": "Вернуться к началу",
        "anamnesis-title": "Заполните форму истории болезни",
        "anamnesis-description": "Отсканируйте QR code, чтобы удобно заполнить форму истории болезни на своем смартфоне.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Вы зарегистрированы",
        "card-expired-info-v2": "Обратитесь на ресепшен."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Проверьте свои данные",
          "balance-prefix": "При сохранении:",
          "balance-direct-v2": "Сохранено сразу: {{count}}",
          "balance-reception-v2": "Проверит ресепшен: {{count}}",
          "chip-reception-v2": "Изменения проверяет наш ресепшен",
          "chip-changed": "Изменено: {{count}}",
          "remove": "Удалить",
          "example-email": "напр. imya@primer.ru",
          "example-phone": "напр. 0171 1234567",
          "intro-v2": "Ваша регистрация завершена. Эти данные ещё верны? Проверка добровольная.",
          "auto-hide": "Показанные значения через короткое время снова скрываются."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Мы передали эти данные на ресепшен.",
          "banner-done-v2": "Спасибо! Мы получили ваши данные.",
          "footer-v2": "Все остальные данные остаются без изменений."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Из соображений защиты данных мы закрыли показ. Ваша регистрация всё равно завершена. Об изменениях можно в любое время сообщить на ресепшене."
        }
      },
      "progress": {
        "identify": "Регистрация",
        "insurance": "Страховка",
        "done": "Готово"
      },
      "dob-format-hint": "Например 01.10.1980",
      "dob-required": "Введите дату рождения.",
      "insurance-label": {
        "GKV": "Обязательное страхование",
        "PKV": "Частное страхование",
        "SELFPAY": "Оплата самостоятельно"
      }
    },
    "emergency": {
      "title": "Острая экстренная помощь!",
      "label": "Чрезвычайная ситуация",
      "subtitle": "Этот сигнал слышен только на месте и не вызвал помощь. При острой или потенциально угрожающей жизни ситуации звоните 112.",
      "call-emergency": "Вызов экстренных служб (112)",
      "stop-sound": "Остановить звук",
      "play-sound": "Воспроизведение звука",
      "back-to-start": "К началу",
      "headline": "Немедленно обратитесь к персоналу на ресепшене. При угрозе жизни звоните 112."
    },
    "help-reception": "Помощь на стойке регистрации",
    "help-reception-toast": "Пожалуйста, свяжитесь со стойкой регистрации. Мы рады помочь.",
    "language-entry": {
      "title": "Выберите язык"
    },
    "loading": "Загрузка…",
    "step-progress-label": "Ход выполнения",
    "step-progress-phase": "Раздел {{current}} из {{total}}: {{phase}}",
    "step-progress-substep": "Часть {{current}} из {{total}}",
    "step-progress-complete": "Завершено",
    "identification": {
      "title": "Кто вы?",
      "lead": "Быстрее всего — с вашей медицинской страховой картой. Можно также искать по имени.",
      "lead-card-only": "Пожалуйста, вставьте медицинскую страховую карту в кард-ридер.",
      "mode-label": "Как вы хотите зарегистрироваться?",
      "mode-card": "Картой",
      "mode-search": "Поиск по имени",
      "mode-create": "Впервые в практике",
      "card": {
        "loading": "Подготовка кард-ридера …",
        "checking": "Проверка кард-ридера …",
        "insert-title": "Пожалуйста, вставьте медицинскую страховую карту в кард-ридер.",
        "insert-detail": "Мы считываем ваши данные автоматически.",
        "detected": "Карта распознана",
        "read": "Считать карту",
        "reading": "Карта считывается …",
        "reading-hint": "Пожалуйста, не вынимайте карту.",
        "no-terminal-title": "Кард-ридер недоступен",
        "help-with-search": "Пожалуйста, найдите себя по имени или спросите на ресепшене.",
        "help-reception": "Пожалуйста, обратитесь на ресепшен — мы с радостью поможем.",
        "unreadable-title": "Карта распознана, но не читается",
        "error-title": "Не удалось считать карту",
        "not-unique": "Не удалось однозначно сопоставить вас с этой картой. Пожалуйста, найдите себя по имени или спросите на ресепшене.",
        "no-match": "По этой карте данных не найдено. Пожалуйста, найдите себя по имени или спросите на ресепшене.",
        "without-card": "Продолжить без карты"
      },
      "lookup": {
        "lead": "Пожалуйста, введите фамилию и дату рождения.",
        "first-name": "Имя",
        "last-name": "Фамилия",
        "dob": "Дата рождения",
        "dob-hint": "Формат: ДД.ММ.ГГГГ",
        "search": "Найти",
        "confirm": "Да, это я",
        "found-title": "Мы вас нашли",
        "found-body": "Пожалуйста, подтвердите, что это вы.",
        "first-name-needed-title": "Пожалуйста, укажите своё имя",
        "first-name-needed-body": "Чтобы мы нашли вас однозначно. Затем нажмите «Найти».",
        "ambiguous-title": "Не удалось однозначно вас найти",
        "ambiguous-body": "Пожалуйста, обратитесь на ресепшен — мы с радостью поможем.",
        "not-found-title": "Подходящие данные не найдены",
        "not-found-body": "Пожалуйста, проверьте введённые данные.",
        "error-title": "Поиск сейчас невозможен",
        "error-body": "Пожалуйста, попробуйте ещё раз или спросите на ресепшене."
      },
      "create": {
        "insurance-question": "Как вы застрахованы?",
        "insurance-required": "Пожалуйста, выберите вид страховки.",
        "error-title": "Не удалось сохранить ваши данные",
        "error-body": "Пожалуйста, попробуйте ещё раз или спросите на ресепшене."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Сначала разблокируйте",
      "subtitle": "FrontDesk+ должен быть активирован в вашем программном обеспечении.",
      "step1": "Сделайте заказ в SolStore (или ваш партнер Doc-Cirrus сделает заказ за вас).",
      "step2": "После активации активируйте в inSuite в разделе «inSuite Sols» (права администратора).",
      "step3": "Откройте администрирование Bridge → «Добавить устройство».",
      "cta": "Все готово - идем дальше"
    },
    "welcome": {
      "title": "Добавьте это устройство в практику",
      "scan": "Сфотографируйте код",
      "prepare-link": "Нет кода в inSuite?",
      "language": "Язык"
    },
    "scan": {
      "requesting": "Требуется доступ к камере…",
      "scanning": "Наведите камеру на код",
      "paste": "Вместо этого вставьте",
      "manual-title": "Подключиться вручную",
      "manual-description": "Если QR-код недоступен, данные для подключения возьмите у администрации Bridge.",
      "address-label": "Bridge адрес",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Вставьте SOLTOKEN",
      "manual-submit": "Возьмите на себя управление соединением",
      "error-title": "Код не распознан",
      "camera-denied-title": "Доступ к камере запрещен",
      "camera-denied-hint": "Разрешите доступ к камере в настройках и повторите попытку.",
      "retry": "Попробуйте еще раз"
    },
    "preflight": {
      "title": "Будет настроен",
      "all-green": "Все тесты пройдены",
      "practice": "Упражняться",
      "device-name": "Имя устройства",
      "device-name-placeholder": "например Б. Прием 1",
      "card-reader": "Кардридер",
      "pin": "Новый секретный номер",
      "pin-placeholder": "Четырехзначный PIN-код",
      "finish": "Заканчивать",
      "recheck": "Проверьте еще раз",
      "diagnosis": "Идентификатор диагноза",
      "checklist-error": "Bridge отклонил подключение или недоступен. Проверьте SOLTOKEN и адрес Bridge.",
      "checklist-retry": "Проверить снова",
      "edit-token": "Изменить SOLTOKEN",
      "rescan": "Отсканировать код ещё раз"
    },
    "persisting": "Сохранение настроек …",
    "success": {
      "title": "Устройство добавлено",
      "detail": "Устройство только что появилось на учебном ПК.",
      "starting": "Режим пациента запускается…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Подключение к программному обеспечению практики",
        "fix": "Bridge Проверьте соединение и адрес сервера."
      },
      "missing_insuite_url": {
        "label": "inSuite адрес",
        "fix": "Сканируйте QR-код еще раз — адрес отсутствует."
      },
      "missing_server_token": {
        "label": "Токен сервера",
        "fix": "Сканируйте QR-код еще раз — жетон отсутствует."
      },
      "missing_gateway_session": {
        "label": "Сеанс Gateway",
        "fix": "Залогиньтесь еще раз — сессия отсутствует."
      },
      "missing_gateway_enrollment": {
        "label": "Регистрация устройства",
        "fix": "Зарегистрируйте устройство на Gateway."
      },
      "gateway_not_ready": {
        "label": "Gateway готовность",
        "fix": "Подождите, пока Gateway завершит настройку."
      },
      "token_verification_failed": {
        "label": "Проверка токена",
        "fix": "Проверьте токен сервера или соединение Bridge."
      },
      "session_expired": {
        "label": "встреча",
        "fix": "Срок сеанса истек – войдите снова."
      },
      "device_revoked": {
        "label": "Статус устройства",
        "fix": "Это устройство заблокировано. Свяжитесь с практикой."
      },
      "missing_practice_name": {
        "label": "Название практики",
        "fix": "Не удалось загрузить название медицинской практики (inSuite)."
      },
      "missing_device_name": {
        "label": "Имя устройства",
        "fix": "Пожалуйста, введите имя устройства."
      },
      "telematik_unavailable": {
        "label": "Телематическая инфраструктура",
        "fix": "Необязательно — проверка карты остается возможной, как только ТИ станет доступен."
      },
      "selected_card_reader_unavailable": {
        "label": "Кардридер",
        "fix": "Необязательно — выберите или подключите кард-ридер."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Необязательно — вставьте удостоверение о медицинской практике (SMC-B)."
      }
    },
    "token": {
      "title": "Введите SOLTOKEN",
      "description": "По соображениям безопасности QR-код не содержит SOLTOKEN. Скопируйте его в inSuite в разделе «Sol-Aktivierung» (FrontDesk+) и вставьте сюда.",
      "submit": "Далее",
      "rescan": "Отсканировать код ещё раз"
    }
  }
}
